// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RHn_","title":"styles_title__2UkS3"};